import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Popup, PopupButtons, PopupContent } from '..';
import { Button, Loader } from '../..';

interface IConfirmPopupProps {
    title: string;
    onConfirm: () => void;
    onCancel: () => void;
    type?: string;
    confirmButtonText?: string;
    secondaryButtonText?: string;
    isLoading?: boolean;
    skipHeaderTranslation?: boolean;
    multilineHeader?: boolean;
}

export const ConfirmPopup: FC<IConfirmPopupProps> = ({
    type,
    title,
    confirmButtonText,
    onConfirm,
    onCancel,
    isLoading,
    children,
    skipHeaderTranslation,
    multilineHeader,
    secondaryButtonText,
}) => (
    <Popup
        show
        type={type || ''}
        headertext={title}
        skipHeaderTranslation={skipHeaderTranslation}
        multilineHeader={multilineHeader}
        onClosePopup={onCancel}
    >
        <PopupContent className="d-flex flex-column my-3">
            {isLoading ? (
                <div className="d-flex justify-content-center">
                    <Loader size="lg" show />
                </div>
            ) : (
                children
            )}
        </PopupContent>

        <PopupButtons className="justify-content-end">
            <Button variant="secondary" className="mr-md-2" onClick={onCancel}>
                <FormattedMessage id={secondaryButtonText || 'CANCEL'} />
            </Button>
            <Button onClick={onConfirm} disabled={isLoading}>
                <FormattedMessage id={confirmButtonText || 'OK'} />
            </Button>
        </PopupButtons>
    </Popup>
);
